import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { capitalize } from 'lodash';
import Async from '../../../core/layout/Async';
import Row from '../../../core/layout/Row';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';

const BannerList = (props) => {
  return (
    <Async fetching={props.fetching}>
      <Row>
        <Table
          lazy
          rowKey="id"
          pagination={props.pagination}
          onChange={props.onChange}
          rows={props.banners}
          columns={[
            {
              label: 'Name',
              path: 'name',
              sort: true,
              sortOrder: props.sortedInfo.columnKey === 'name' && props.sortedInfo.order,
            },
            {
              label: 'Position',
              path: 'position',
              sort: true,
              sortOrder: props.sortedInfo.columnKey === 'position' && props.sortedInfo.order,
              width: '100px',
            },
            {
              label: 'Link',
              path: 'link',
            },
            {
              label: 'Status',
              path: 'status',
              width: '100px',
              render: (value) => capitalize(value),
            },
            {
              label: 'Stage',
              path: 'stage',
              width: '100px',
              render: (value) => {
                if (!value) return 'All';
                return capitalize(value);
              },
            },
            {
              label: 'Target',
              path: 'targetAudience',
              width: '100px',
              render: (value) => {
                if (!value) return 'All';
                return capitalize(value.replace('_', ' '));
              },
            },
            {
              label: 'Initial Date',
              path: 'initialDate',
              sort: true,
              width: '100px',
              sortOrder: props.sortedInfo.columnKey === 'initialDate' && props.sortedInfo.order,
              render: (value) => moment(value).utc().format('YYYY-MM-DD'),
            },
            {
              label: 'Final Date',
              path: 'finalDate',
              sort: true,
              width: '100px',
              sortOrder: props.sortedInfo.columnKey === 'finalDate' && props.sortedInfo.order,
              render: (value) => moment(value).utc().format('YYYY-MM-DD'),
            },
            {
              label: 'Segments',
              path: 'segments',
              width: '270px',
              render: (value) => (value || []).map((seg) => seg.name).join(', '),
            },
            {
              label: 'Actions',
              width: '120px',
              render: (cell, row) => (
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <Button
                    icon="edit"
                    tooltip="Edit banner"
                    onClick={() =>
                      browserHistory.push({
                        pathname: `/banners/${row.id}`,
                        state: { from: { text: 'Banners', pathname: '/banners' } },
                      })
                    }
                  />
                  <Button icon="close-circle" tooltip="Delete banner" onClick={() => props.onDelete(row)} />
                </div>
              ),
            },
          ]}
        />
      </Row>
    </Async>
  );
};

BannerList.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      position: PropTypes.number.isRequired,
      link: PropTypes.string,
      status: PropTypes.string.isRequired,
      stage: PropTypes.string.isRequired,
      targetAudience: PropTypes.string.isRequired,
      webImageUrl: PropTypes.string.isRequired,
      mobileImageUrl: PropTypes.string.isRequired,
      segments: PropTypes.arrayOf(PropTypes.string).isRequired,
      initialDate: PropTypes.string.isRequired,
      finalDate: PropTypes.string.isRequired,
    })
  ).isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  sortedInfo: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
};

BannerList.defaultProps = {
  sortedInfo: {},
};

export default BannerList;
